import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../../services/pet.service';
declare var $: any;


@Component({
  selector: 'ngx-work-treatment-plan',
  templateUrl: './treatment-plan.component.html' 
})
export class TreatmentPlanComponent implements OnInit {

  private _pet_no: number;
  noteText: string = '';
  request_sequence: number = 0;

  constructor(
    public petService:PetService,
  ) { }

  @Input() set pet_no(value: number) {
    this._pet_no = value;  
    this.petService.getPetTreatmentPlan(this.pet_no, this.petService.userData.clinic_no).then(() => { console.log(this.petService.pet_treatment_plan) });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  ngOnInit(): void { 
  }

  noteBtnClick(item: any){
    this.noteText = item.remarks;
    this.request_sequence = item.tran_sequence;
    $('#NoteModal').modal('show');

  }

  saveNote(){
    this.petService.setupTreatmentDets(this.request_sequence, this.noteText).then(() => {
      $('#NoteModal').modal('hide');
      this.petService.getPetTreatmentPlan(this.pet_no, this.petService.userData.clinic_no).then(() => { console.log(this.petService.pet_treatment_plan) });
    });
  }

}
